import { memo } from 'react';
import type { Descendant} from 'slate';
import { Element, Text } from 'slate';
import type { EditableProps } from 'slate-react/dist/components/editable';

type RenderElement = NonNullable<EditableProps['renderElement']>;
type RenderLeaf = NonNullable<EditableProps['renderLeaf']>;

type NodeProps = {
  node: Descendant;
  renderElement: RenderElement;
  renderLeaf: RenderLeaf;
};

const Node = (props: NodeProps) => {
  const { node, renderElement, renderLeaf } = props;

  if (Element.isElement(node)) {
    return (
      <>
        {renderElement({
          attributes: {} as any,
          children: (
            <>
              {node.children.map((child, i) => (
                <Node key={i} node={child} renderElement={renderElement} renderLeaf={renderLeaf} />
              ))}
            </>
          ),
          element: node,
        })}
      </>
    );
  } else if (Text.isText(node)) {
    return (
      <>
        {renderLeaf({
          attributes: {} as any,
          children: node.text,
          leaf: node,
          text: node,
        })}
      </>
    );
  }

  console.warn('Unknown node type:', node);
  return null;
};

type Props = {
  value: Descendant[];
  renderElement: RenderElement;
  renderLeaf: RenderLeaf;
};

export const EditorParser = memo((props: Props) => {
  const { value = [], renderElement, renderLeaf } = props;

  return (
    <>
      {value.map((node, i) => (
        <Node key={i} node={node} renderElement={renderElement} renderLeaf={renderLeaf} />
      ))}
    </>
  );
});

EditorParser.displayName = 'EditorParser';
